<template>
  <!-- Sim/Não em pílulas, como nas perguntas da avaliação do app -->
  <div class="d-flex gap-2 app-yes-no" role="radiogroup">
    <button
      v-for="opt in options"
      :key="String(opt.value)"
      type="button"
      class="app-yes-no-pill text-action"
      :class="{ selected: modelValue === opt.value }"
      :disabled="disabled"
      :id="idPrefix ? `${idPrefix}-${opt.value ? 'sim' : 'nao'}` : undefined"
      role="radio"
      :aria-checked="modelValue === opt.value"
      @click="emit('update:modelValue', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ modelValue?: boolean | null; disabled?: boolean; idPrefix?: string }>(), {
  modelValue: null,
  disabled: false,
  idPrefix: "",
});
const emit = defineEmits<{ "update:modelValue": [value: boolean] }>();
const options = [
  { value: true, label: "Sim" },
  { value: false, label: "Não" },
];
</script>

<style scoped lang="scss">
@import "@/assets/theme/scss/user-variables";

.app-yes-no-pill {
  min-width: 56px;
  height: 40px;
  padding: 0 18px;
  border-radius: 20px;
  border: 1px solid $primary10;
  background: $white;
  color: $primary;
}

.app-yes-no-pill.selected {
  background: $secondary;
  border-color: $secondary;
}

.app-yes-no-pill:disabled {
  cursor: default;
  opacity: 1;
}
</style>
